import { jsx as _jsx } from "react/jsx-runtime";
import RoleTagList from '../RoleTagList';
export const RolesCell = ({ rowType, roles, defaultRoleIndex }) => {
    const isVariant = rowType === 'variant';
    const rolesToShow = isVariant
        ? roles
        : [roles[defaultRoleIndex]].filter(Boolean);
    return (_jsx(RoleTagList, { roles: rolesToShow, defaultRoleIndex: isVariant ? defaultRoleIndex : undefined }));
};
